document.addEventListener("DOMContentLoaded", () => {

    if (typeof subscribe === "undefined") {
        console.log("Shopify subscribe() not found.");
        return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    console.log("Variant Changed:", data.variant);

        if (!data || !data.variant) return;

        const variantId = data.variant.id;

        const json = document.getElementById("variant-data-json");

        if (!json) return;

let variants;

try {
    variants = JSON.parse(json.textContent);
} catch (e) {
    console.error("Variant JSON Error:", e);
    console.log(json.textContent);
    return;
}
        const variant = variants.find(v => Number(v.id) === Number(variantId));

        if (!variant) return;

        update("vc-badge", variant.badge);
        update("vc-heading", variant.heading);
        update("vc-short", variant.short_description);
        update("vc-long", variant.long_description);
const color = data.variant.title;
filterGallery(color);        
// update("vc-features", variant.features);
        // update("vc-benefits", variant.benefits);
        // update("vc-specifications", variant.specifications);
        // update("vc-care", variant.care);
        // update("vc-shipping", variant.shipping);
        // update("vc-faq", variant.faq);

    });

    function update(id, value) {

        const el = document.getElementById(id);

        if (!el) return;

        el.innerHTML = value || "";

    }
/* ===========================
   Variant Gallery
=========================== */
// function filterGallery(color) {

//     color = color.toLowerCase().trim();

//     // Main images
//     document.querySelectorAll(".product__media-item").forEach((item) => {

//         const img = item.querySelector("img");

//         if (!img) return;

//         const alt = (img.alt || "").toLowerCase();

//         item.hidden = !alt.includes(color);

//     });

//     // Thumbnails
//     document.querySelectorAll(".thumbnail-list__item").forEach((item) => {

//         const img = item.querySelector("img");

//         if (!img) return;

//         const alt = (img.alt || "").toLowerCase();

//         item.hidden = !alt.includes(color);

//     });

// }
});